import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { forkJoin, from, Observable } from 'rxjs';
import {  map } from 'rxjs/operators';
import { URLS } from "../../../../config/api.config";
import { CommonService } from "../../../helpers/common.service";
import { HTTP } from "@awesome-cordova-plugins/http/ngx";
import { CustomEncryption } from "../../../../config/custom-encrypt";
import moment from "moment";
import { environment } from "../../../../environments/environment";
import { StorageServiceAAA } from "../../../helpers/aaa-storage.service";


@Injectable()
export class GuestDashBoardService {
	private getBankName = URLS.getBankName;
	private fileUploadService = URLS.fileUploadService;
	private arnNodeUrl = URLS.arnNodeUrl;
	private generateTokenExtentedApi = URLS.generateTokenExtentedApi
	public options: any;
	private nativeHeaders: any = environment['nativeHeaders'];
	//private gatewaySubscriptionKey = environment['gatewaySubscriptionKey'];
	private globalCheckSumkey = environment['production'] === true ?  'AaAz7LiVEcdEci1K' : 'AaAz7PpYScdEci1K'

	private userOnboard = URLS.userOnboard;
	private leadSearchToken = URLS.crmLogin;			
	private verifypan = URLS.verifyPan;
	private guestDetails = URLS.guestDetails;
	private GuestCaptureDetails = URLS.GuestCaptureDetails;
	private captureGuestPayment = URLS.captureGuestPayment;
	private VerifyGuestMobileOrEmail = URLS.VerifyGuestMobileOrEmail;
	private loginSearch = URLS.loginSearch;
	public headParamLogin: any =  {
		Username:environment.CrmUsername,
		Password: environment.CrmPassword
	};
	private gatewaySubscriptionKey: any = environment['gatewaySubscriptionKey'];
	env:any;

	constructor(private httpClient: HttpClient,
		private nativeHttp: HTTP,
		private commonService: CommonService,
		private cipherText: CustomEncryption,
	private storage: StorageServiceAAA) {
						this.storage.get('envSettings').then(res=>{
							this.env = res;
							this.options = this.env['headersParams-optionalHeaders']
						})
	}

	public getUserOnboardData(mob: any): Observable<{}> {
		let params = {
			"MobileNo": mob,
			"Key": '446794970AAA1237ab394d176612f8c6',
			"AppName": 'AAA',
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : this.gatewaySubscriptionKey.aaa,
			'appID': localStorage.getItem('appID') || ''
		};
		if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('json');
		return this.commonService.isApp() ? from(this.nativeHttp.post(this.userOnboard.url, params, Object.assign(obj, this.nativeHeaders, this.options))).pipe(map(response => {
			return JSON.parse(response['data'] as any);
		})) : this.httpClient.post(this.userOnboard.url, params, { headers: new HttpHeaders(obj) });
	}

	public getTokenforPANVerification(): Observable<{}> {
		let params = new URLSearchParams();
		params.set("grant_type", 'password');
		params.set("username", 'IiflOnBoarding');
		params.set("password", 'AHx1InWid6tsi194sEwDBhbFAGjmHutbsy8r5eMwVm+xMk3fI6NrGoaRMnQCzNZiYA==');
	  

	let obj: any = {
		'Ocp-Apim-Subscription-Key': this.gatewaySubscriptionKey.eaccount,
		'appID': localStorage.getItem('appID') || '',
		'Content-Type': 'application/x-www-form-urlencoded'
	}

	if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('urlencoded');
	return this.commonService.isApp() ? from(this.nativeHttp.post(`${this.verifypan.url}token`, params.toString(), {obj,...this.nativeHeaders,...this.options})).pipe(map(response => {
		return JSON.parse(response['data'] as any);
	})) : this.httpClient.post(`${this.verifypan.url}token`, params.toString(), { headers: obj});
	}

	public verifyPanNo(data: any, cookievalue: string) {
		let params = {
			head: {
				"UniqueKey": "MFRSLO04",
				"AppName": this.verifypan.appName,
				"AppVer": this.verifypan.appVer,
				"OsName": this.verifypan.osName
			}, "body": data
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key': this.gatewaySubscriptionKey.eaccount,
			'appID': localStorage.getItem('appID') || '',
			'Authorization' : 'Bearer ' + cookievalue
		}

		if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('json');
		return this.commonService.isApp() ? from(this.nativeHttp.post(`${this.verifypan.url}api/FranchiseeOnBoardingAPI/CheckPanExistV2`, params, Object.assign(obj, this.nativeHeaders))).pipe(map(response => {
			return JSON.parse(response['data'] as any);
		})) : this.httpClient.post(`${this.verifypan.url}api/FranchiseeOnBoardingAPI/CheckPanExistV2`, params, { headers: new HttpHeaders(Object.assign(obj)) });
	}

	public guestSaveDetails(data: any, formName: any) {
		let checkSumKey = this.cipherText.generateCheckSumKey();
		let stringValue = ''
		let urlEndPoint = ''
		if (formName == 'basicDetails') {
			stringValue = `${data.PanNo}_${data.FullName}_${data.FatherName}_${data.EmailID}_${data.MobileNumber}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`
			data.PanNo = this.cipherText.createChecksum(data.PanNo, checkSumKey);
			data.DOB = moment(data.DOB).format('DDMMYYYY');
		    data.MobileNumber = this.cipherText.createChecksum(data.MobileNumber, checkSumKey);
			urlEndPoint = 'SaveGuestBasicDetails'
		} else if (formName == 'bankDetails') {
			stringValue = `${data.MobileNumber}_${data.AccountNumber}_${data.IFSCCode}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`
			data.MobileNo = this.cipherText.createChecksum(data.MobileNumber, checkSumKey);
			urlEndPoint = 'SaveGuestBankdetails_V1'
		} else if (formName == 'addressDetails') {
			stringValue = `${data.MobileNumber}_${data.Country}_${data.City}_${data.State}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`
			data.MobileNumber = this.cipherText.createChecksum(data.MobileNumber, checkSumKey);
			urlEndPoint = 'SaveGuestAddressdetailsV1'
		}

		const checkSumValue = this.cipherText.createChecksum(stringValue, this.globalCheckSumkey);


		let params = {
			"head": {
				"RequestCode": "SaveGuestBasicDetails",
				"Key": this.env.verifyGuestandExtendedApi.key,
				"AppName": this.guestDetails.appName,
				"AppVer": this.guestDetails.appVer,
				"OsName": this.guestDetails.osName,
				"CheckSum": checkSumValue,
				"CheckSumKey": checkSumKey,
				"Token": localStorage.getItem('JWTToken')
			},
			"body": data
		};
		let obj: any = {
			'Ocp-Apim-Subscription-Key': this.gatewaySubscriptionKey.aaa,
			'appID': localStorage.getItem('appID') || ''
		};

		if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('json');
		return this.commonService.isApp() ? from(this.nativeHttp.post(`${this.guestDetails.url}${urlEndPoint}`, params, Object.assign(obj, this.nativeHeaders))).pipe(map(response => {
			return JSON.parse(response['data'] as any);
		})) : this.httpClient.post(`${this.guestDetails.url}${urlEndPoint}`, params, { headers: new HttpHeaders(Object.assign(obj)) });
	}

	public searchLeadToken(){
		let params = {};
		let obj = {
			'UserKey': this.loginSearch.userKey,
			'Authorization': 'Basic ' + btoa(`${this.headParamLogin.Username}:${this.headParamLogin.Password}`),
			'Ocp-Apim-Subscription-Key': this.gatewaySubscriptionKey.iiflcrm,
			'appID': localStorage.getItem('appID') || ''
		};
		if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('json');
		return this.commonService.isApp() ? from(this.nativeHttp.post(this.leadSearchToken.url, params, Object.assign(obj, this.nativeHeaders))).pipe(map(response => {
			return JSON.parse(response['data'] as any);
		})) : this.httpClient.post(this.leadSearchToken.url, params, { headers: new HttpHeaders(Object.assign(obj))});
	}

	public guestCaptureStatus(endPoint: string, requestCode: string,env?:any) {
		if(this.env == undefined || this.env == null){
            this.env = env
        }
		let mobileNo = localStorage.getItem('GuestMobileNumber')
		let checkSumKey = this.cipherText.generateCheckSumKey();
		let stringValue = `${mobileNo}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`
		const checkSumValue = this.cipherText.createChecksum(stringValue, this.globalCheckSumkey);
		mobileNo = this.cipherText.createChecksum(mobileNo, checkSumKey);

		let params = {
			"head": {
				"RequestCode": requestCode,
				"Key": this.env.verifyGuestandExtendedApi.key,
				"AppName": this.GuestCaptureDetails.appName,
				"AppVer": this.GuestCaptureDetails.appVer,
				"OsName": this.GuestCaptureDetails.osName,
				"CheckSum": checkSumValue,
				"CheckSumKey": checkSumKey,
				"Token": localStorage.getItem('JWTToken')
			},
			"body": {
				'Mobilenumber': mobileNo
			}
		};

		let obj: any = {
			'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa,
			'appID': localStorage.getItem('appID') || ''
		};
		if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('json');
		return this.commonService.isApp() ? from(this.nativeHttp.post(`${this.GuestCaptureDetails.url}${endPoint}`, params, Object.assign(obj, this.nativeHeaders))).pipe(map(response => {
			return JSON.parse(response['data'] as any);
		})) : this.httpClient.post(`${this.GuestCaptureDetails.url}${endPoint}`, params, { headers: new HttpHeaders(Object.assign(obj)) });
	}

	capturePayment(data:any){
		let checkSumKey =  this.cipherText.generateCheckSumKey();
		const stringValue = `${localStorage.getItem('GuestMobileNumber')}_${data.PaymentID}_${data.OrderID}_${data.Status}_${data.Amount}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`
		let checkSum = this.cipherText.createChecksum(stringValue,this.globalCheckSumkey)
		data.MobileNo = this.cipherText.createChecksum(localStorage.getItem('GuestMobileNumber'), checkSumKey);
		let params = { 
			"head": {
				"RequestCode": "SaveGuestPaymentdetails",
				"Key": this.captureGuestPayment.key,
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"CheckSum": checkSum,
				"CheckSumKey": checkSumKey,
				"Token":localStorage.getItem('JWTToken')
			},
			"body": data
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key': this.gatewaySubscriptionKey.aaa,
			'appID': localStorage.getItem('appID') || ''
		};

		if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('json');
		return this.commonService.isApp() ? from(this.nativeHttp.post(`${this.captureGuestPayment.url}`, params, Object.assign(obj, this.nativeHeaders))).pipe(map(response => {
			return JSON.parse(response['data'] as any);
		})) : this.httpClient.post(`${this.captureGuestPayment.url}`, params, { headers: new HttpHeaders(Object.assign(obj)) });
	}

	public verifyEmail(data: any, cookievalue: any, checkSumString:any) {
		data.CheckSum = this.cipherText.createChecksum(checkSumString, environment.extentedChecksumkey)
		let params = {
			head: {
				"UniqueKey": environment.UniqueKey,
				 "appName": "ExtendedAPI",
				"AppName": this.VerifyGuestMobileOrEmail.appName,
				"AppVer": this.VerifyGuestMobileOrEmail.appVer,
				"OsName": this.VerifyGuestMobileOrEmail.osName,
				"requestCode": "VerifyGuestMobileOrEmail",
				"UserName": localStorage.getItem('extUserName'),
        		"Token": localStorage.getItem('extToken')
			}, "body": data
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key': this.gatewaySubscriptionKey.extentedapi,
			'appID': localStorage.getItem('appID') || '',
		}


		if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('json');
		return this.commonService.isApp() ? from(this.nativeHttp.post(`${this.VerifyGuestMobileOrEmail.url}`, params, Object.assign(obj, this.nativeHeaders))).pipe(map(response => {
			return JSON.parse(response['data'] as any);
		})) : this.httpClient.post(`${this.VerifyGuestMobileOrEmail.url}`, params, { headers: new HttpHeaders(Object.assign(obj)) });
	}


	public generateTokenExtented(){
		let params = environment.extentedapiCredentials;
		let obj: any = {
			"Ocp-Apim-Subscription-Key": this.gatewaySubscriptionKey.extentedapi,
   			"Content-Type": "application/json"
		}


		if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('json');
		return this.commonService.isApp() ? from(this.nativeHttp.post(`${this.generateTokenExtentedApi.url}`, params, Object.assign(obj, this.nativeHeaders))).pipe(map(response => {
			return JSON.parse(response['data'] as any);
		})) : this.httpClient.post(`${this.generateTokenExtentedApi.url}`, params, { headers: new HttpHeaders(Object.assign(obj)),withCredentials: false  });
	}

	public arnNodeScrapping(id:any){
        const params = {
            id: id
        }
        let obj: any = {
            'Ocp-Apim-Subscription-Key' : this.gatewaySubscriptionKey.aaa,
            'appID': localStorage.getItem('appID') || ''
        }
        if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('json');
        return this.commonService.isApp() ? from(this.nativeHttp.post(this.arnNodeUrl.url, params, Object.assign(obj, this.nativeHeaders))).pipe(map(response => {
            return JSON.parse(response['data'] as any);
        })) : this.httpClient.post(this.arnNodeUrl.url, params, { headers: new HttpHeaders(Object.assign(obj)) });
     }

	 public sendFileToserver( fromName: string, fileName?: any) {
		const body:any = {}
		let obj: any = {
            'Ocp-Apim-Subscription-Key' : this.gatewaySubscriptionKey.aaa,
            'appID': localStorage.getItem('appID') || ''
        }
		let checkSumKey =  this.cipherText.generateCheckSumKey();
		const stringValue = `${localStorage.getItem('GuestMobileNumber')}_${fileName.type.split('.')[1]}_${fromName === 'bankDetails' ? 'Bank_Prof' : 'Address_Prof'}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`
		let checkSum = this.cipherText.createChecksum(stringValue,this.globalCheckSumkey)
		const MobileNo = this.cipherText.createChecksum(localStorage.getItem('GuestMobileNumber'), checkSumKey);
				let data ={
					"head": {
						"RequestCode": "GuestFileUpload",
						"Key": this.fileUploadService.key,
						"AppName": this.fileUploadService.appName,
						"AppVer": "01",
						"OsName": "Android",
						"CheckSum": checkSum,
						"CheckSumKey": checkSumKey,
						"Token": localStorage.getItem('JWTToken')
					},
					"body": {
						"Mobilenumber": MobileNo,
						"Documentupload": fileName.url.split(',')[1],
						"FileType": fileName.type.split('.')[1],
						"UploadType": fromName === 'bankDetails' ? 'Bank_Prof' : 'Address_Prof'
					}
				}
				return this.httpClient.post(this.fileUploadService.url,data,{ headers: obj });
	}

	 public getBankNameDetails(item?: any) {
		let checkSumKey =  this.cipherText.generateCheckSumKey();
		const stringValue = `${localStorage.getItem('GuestMobileNumber')}_${item}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`
		let checkSum = this.cipherText.createChecksum(stringValue,this.globalCheckSumkey)
		const MobileNo = this.cipherText.createChecksum(localStorage.getItem('GuestMobileNumber'), checkSumKey);
		 let data ={
					"head": {
						"RequestCode": "GuestFileUpload",
						"Key": this.getBankName.key,
						"AppName": this.getBankName.appName,
						"AppVer": "01",
						"OsName": "Android",
						"CheckSum": checkSum,
						"CheckSumKey": checkSumKey,
						"Token": localStorage.getItem('JWTToken')
					},
					"body": {
						"Mobilenumber": MobileNo,
						"IFSCCode": this.cipherText.createChecksum(item, checkSumKey),
					}
				}
        let obj: any = {
            'Ocp-Apim-Subscription-Key' : this.gatewaySubscriptionKey.aaa,
            'appID': localStorage.getItem('appID') || ''
        }
        if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('json');
        return this.commonService.isApp() ? from(this.nativeHttp.post(this.getBankName.url, data, Object.assign(obj, this.nativeHeaders))).pipe(map(response => {
            return JSON.parse(response['data'] as any);
        })) : this.httpClient.post(this.getBankName.url, data, { headers:obj });
	}
	
}
